var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppAppstore = function SvgAppAppstore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_4026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 0H6.66667C2.98477 0 0 2.98477 0 6.66667V17.3333C0 21.0152 2.98477 24 6.66667 24H17.3333C21.0152 24 24 21.0152 24 17.3333V6.66667C24 2.98477 21.0152 0 17.3333 0Z",
    fill: "url(#paint0_linear_243_4026)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54937 15.5293C8.07471 15.5293 8.40004 15.66 8.69871 15.812C8.93337 15.932 9.11204 16.0773 9.17871 16.1333C9.19337 16.1467 9.19737 16.172 9.18804 16.1907L8.21871 18.0413C8.00937 18.4413 7.62537 18.6667 7.23071 18.6667C7.04004 18.6667 6.84804 18.6133 6.67071 18.5053C6.12404 18.1667 5.94671 17.376 6.25737 16.7813L6.62004 16.0907C6.71071 15.9173 6.84137 15.7747 7.00271 15.6813C7.14137 15.6 7.32671 15.5293 7.54937 15.5293ZM14.4987 9.28C14.5254 9.244 14.576 9.248 14.596 9.28666L17.036 13.9213H19.0694C19.584 13.9213 20 14.3747 20 14.932C20 15.4893 19.584 15.9427 19.0694 15.9427H18.0987L18.7374 17.156C18.9907 17.6387 18.836 18.256 18.3907 18.5333C18.244 18.624 18.0867 18.6667 17.9294 18.6667C17.6067 18.6667 17.292 18.484 17.1214 18.1573L15.9547 15.9427L14.892 13.9213L14.0334 12.2893C13.7987 11.8453 13.7854 11.3067 13.8787 10.696C13.9387 10.3 14.0507 9.96933 14.2027 9.72266C14.2987 9.568 14.4214 9.38933 14.4987 9.28ZM10.848 5.46533C11.3214 5.19066 11.9227 5.35866 12.192 5.83866L12.4907 6.36933L12.756 5.89866C13.0254 5.41866 13.628 5.252 14.1 5.52533C14.572 5.8 14.736 6.412 14.4667 6.892L13.6267 8.38666L12.4907 10.4053L10.736 13.528H13.0667C13.4 13.528 13.7867 13.5853 14.0214 13.888C14.256 14.1893 14.3387 14.4773 14.3387 14.8293C14.3387 15.18 14.3187 15.5293 13.7307 15.5293H6.31737C5.77471 15.5293 5.33337 15.0813 5.33337 14.5293C5.33337 13.976 5.77337 13.528 6.31871 13.528H8.46537L11.3587 8.38666L10.48 6.83066C10.2107 6.35066 10.3747 5.74 10.8467 5.46533H10.848Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_243_4026",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_4026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppAppstore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "app-appstore.6dc301aea38c4a793342210c8ae6f28d.svg";